import { sdk } from 'src/utilities/sdk';
import { IGroup } from 'src/utilities/useSearchHooks';
import { camelizeResponseData } from 'src/utilities/http-data-casing';

export async function getEmployeeGroupsSelections(
  corpId: string,
  employeeId: string
): Promise<IGroup[]> {
  const response = await sdk.http.get(
    `/corp-admin/${corpId}/groups/diners/${employeeId}`
  );
  return camelizeResponseData(response) as IGroup[];
}
